module.exports = __webpack_public_path__ + "static/img/14.348efe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/14.png
// module id = xdo3
// module chunks = 1